import Util from '../../Common/Util';
import Store from '../../Common/Store';

// 서랍 항목코드 별칭 — 같은 화면을 가리키는 다른 진입코드를 대표 항목으로 모은다.
// (1021: 서류 상세 진입 = 1020 등록 / 4030: 구 발주개수 = 4020 발주)
const SUBTAB_ALIAS = { '1021': '1020', '4030': '4020' };

/**
 * 서랍(햄버거) 동작 모드 — 바꾸려면 이 값만 고치고 `npm run prod` 로 다시 빌드한다.
 *
 *   'overlay' : 서랍은 떠 있는 임시 표면(#jbDrawer 오버레이). 열 때 history 항목을 하나 쌓고,
 *               메뉴로 이동할 때 그 항목을 목적지가 대체(location.replace)한다
 *               → 목적지에서 뒤로 한 번이면 서랍을 열기 전 화면으로 복귀.
 *   'page'    : 서랍은 주소를 가진 목적지 — /m/menu 로 이동한다(MENU_PAGE_URL).
 *               히스토리·뒤로가기·새로고침·딥링크가 전부 브라우저 기본동작으로 해결된다.
 *
 * page 모드에서 #jbDrawer 오버레이는 쓰이지 않는다(openDrawer 가 먼저 페이지로 보낸다).
 */
const DRAWER_MODE = 'page';

/** 'page' 모드의 전체메뉴 주소 — routes/mobile.php · Mobile\MenuController */
const MENU_PAGE_URL = '/m/menu';

/**
 * 톱니 — 전체 서비스 시트 헤더의 설정 버튼.
 * 방사형 직선 8개가 아니라 **윤곽 패스 한 벌**이다 — 선으로 그리면 작은 크기에서 별처럼 보인다.
 */
const GEAR_PATH = '<circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>';

/**
 * 전체 서비스 시트에 **내보낼 소메뉴와 그 순서** — 회원유형별. 값은 _drawerSections() 의 title 이다.
 *
 * ⚠ 목록을 줄이는 일을 _drawerSections() 에서 하지 않는 이유:
 *   그 함수는 서브 페이지 형제탭(showSubTabs → _subTabSection)의 원본이기도 하다. 섹션을 지우면
 *   그 화면 위의 탭줄까지 같이 사라져, 예컨대 설정을 지우는 순간 '소리설정' 으로 갈 길이 없어진다.
 *   그래서 구조는 그대로 두고 **시트에 보일 것만** 여기서 고른다.
 *
 * 여기 빠진 두 섹션은 시트 목록에서만 빠지고 각자 다른 입구를 갖는다.
 *   MY  → SVC_ORDER 순서와 무관하게 목록 맨 위에 고정한다(_menuGridHtml) · 다른 소메뉴와 같은
 *         아코디언 그룹(제목 'MY' + 내정보·서류등록·위치) · 들어가면 형제탭으로 나머지 MY 화면까지
 *   설정 → 시트 헤더의 톱니 · 들어가면 형제탭으로 소리설정까지
 */
const SVC_ORDER = {
    baljoo: ['관리', '충전금', '고객지원'],
    owner:  ['관리', '충전금', '포인트', '장비대금 카드결제', '악덕업자', '고객지원'],
    // 소속기사(직원)는 장비도 정산도 사장 몫이라 충전금·포인트 묶음을 내보내지 않는다.
    // 관리(특차리스트·수발주차단)도 사장이 정하는 관계라 빼고, 카드받기는 낸다 —
    // 결제는 본인이 뛴 현장에서 본인이 받는 돈이고, 화면도 본인 건만 보여준다(CardQueryService).
    staff:  ['장비대금 카드결제', '고객지원'],
};

/**
 * 시트 헤더 아이콘 — 24×24 viewBox, currentColor.
 * 톱니는 윤곽 패스 한 벌로 그린다(방사형 선 8개로 그리면 21px 에서 별처럼 뭉갠다).
 * 달은 라이트에서 빈 달, 다크에서 오렌지로 채워진다 — 채움은 CSS 가 한다(layout/_sidebar.scss).
 * 해 아이콘은 쓰지 않는다 — 톱니와 형태가 겹쳐 두 버튼이 구분되지 않는다.
 */
const SHEET_ICON = {
    gear: GEAR_PATH,
    moon: '<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>',
    close: '<path d="M6 6l12 12M18 6L6 18"/>',
    go:   '<path d="m9 6 6 6-6 6"/>',
};

/** 글자크기 3단계 — 시트 헤더 '가' 는 끝에서 처음으로 돌아온다(Theme.stepFontSize 는 양끝에서 멈춘다). */
const SHEET_FS = ['m', 'l', 'xl'];
const SHEET_FS_LABEL = { m: '보통', l: '크게', xl: '아주크게' };

/**
 * 전체 서비스 — 섹션(소메뉴)별 아이콘 path + 색 계열.
 * 키는 _drawerSections() 의 title. 항목이 1개뿐인 섹션은 헤더 없는 '단독 항목'으로 그려지고,
 * 그때도 같은 아이콘을 왼쪽에 붙인다(_svcItemHtml).
 */
const SVC_ICON = {
    'MY':                 { tone: 'steel',   path: '<circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 4-6 8-6s8 2 8 6"/>' },
    '관리':               { tone: 'violet',  path: '<rect x="5" y="3" width="14" height="18" rx="2"/><path d="M9 7h6M9 11h6M9 15h4"/>' },
    '충전금':             { tone: 'success', path: '<rect x="2" y="6" width="20" height="13" rx="2"/><path d="M2 10h20"/><circle cx="17" cy="14.5" r="1.5"/>' },
    '포인트':             { tone: 'primary', path: '<circle cx="12" cy="12" r="9"/><path d="M12 7v10M9.5 9h3.5a1.8 1.8 0 0 1 0 3.6H9.5"/>' },
    '악덕업자':           { tone: 'danger',  path: '<path d="M12 3 2.5 20h19L12 3z"/><path d="M12 10v4M12 17h.01"/>' },
    '장비대금 카드결제': { tone: 'success', path: '<rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/>' },
    '설정':               { tone: 'steel',   path: '<circle cx="12" cy="12" r="3"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M19 5l-2 2M7 17l-2 2"/>' },
    '고객지원':           { tone: 'steel',   path: '<path d="M4 14v-2a8 8 0 0 1 16 0v2"/><rect x="2.5" y="13" width="4" height="6" rx="1.5"/><rect x="17.5" y="13" width="4" height="6" rx="1.5"/><path d="M20 19a4 4 0 0 1-4 3h-2"/>' },
    // 내부도구 — _toolsHtml('도메인 변경'). 항목이 하나뿐이라 헤더 없이 단독 항목으로 그려지고,
    //   이 아이콘만 그 자리에 쓰인다 (SVC_ICON 조회 키라 이름은 남긴다).
    '내부도구':           { tone: 'steel',   path: '<path d="M12 3l7 3v5c0 4.5-3 7.6-7 9-4-1.4-7-4.5-7-9V6l7-3z"/><path d="M9.5 12l1.8 1.8L15 10"/>' },
};

/** 개발환경 전용 항목이 가는 곳 — 앱 접속 도메인(QA·운영) 전환 브릿지. */
const DEV_BRIDGE_URL = '/m/dev/bridge';

/**
 * 메뉴 사용기록 — 기기(localStorage)가 정본. 화면에는 더 이상 노출하지 않는다
 * ('최근·자주 찾는 메뉴' 칩 섹션을 걷어냈다 — _menuGridHtml).
 *
 * 쓰기(markMenuVisit → _bumpMenuUse)는 그대로 남겨 뒀다 — 화면을 다시 쓰게 되면 바로 쓸 데이터라,
 * 지금은 쌓기만 하고 읽지 않는다. 화면모드·글자크기(`m:ui:*`)와 같은 취급으로 페이지마다
 * 적립요청(sendBeacon)·서랍마다 조회질의를 들이지 않는다.
 * 키에 회원번호를 붙인다 — 한 기기에 여러 회원이 로그인해도 섞이지 않는다(state-conventions §5).
 */
const USE_KEY_PRE   = 'm:menu:use:';
// 보관기간 — 마지막 사용이 이보다 오래된 코드는 적립할 때 함께 버린다(옛 월버킷 배치와 같은 기준).
const USE_KEEP_DAYS = 365;

export default class Layout {
    constructor() {
        // 모바일 메뉴 구조
        G5['MOBILE_MENU'] = {
            "M001": {
                "title": "알림",
                "url": '/m/alim'
            },
            "M002": {
                "title": "수주",
                "url": '/m/soojoo'
            },
            "M003": {
                "title": "발주",
                "url": '/m/bal'
            },
            "M005": {
                "title": "일지",
                "url": '/m/diary'
            },
            "M006": {
                "title": "불러톡",
                "url": '/m/chat'
            },
            "0101": {
                "title": "알림",
                "url": '/m/alim'
            },
            "0102": {
                "title": "일지",
                "url": '/m/diary'
            },
            "0103": {
                "title": "수주",
                "url": '/m/soojoo'
            },
            "0105": {
                "title": "발주",
                "url": '/m/bal'
            },

            // 전체메뉴 페이지 — 서랍 'page' 모드의 목적지.
            // isMenu 면 상단 헤더를 그리지 않는다 — 시트가 자기 헤더를 갖는다(showOldTopNav).
            "0000": {
                "title": "전체메뉴",
                "url": "/m/menu",
                "isMenu": true
            },

            "1000": {
                "title": "MY",
                "url": null
            },
            "1010": {
                "title": "내정보",
                "url": "/m/setting/my"
            },
            // 서랍에 없다(내정보 카드가 진입점) → parent 로 '뒤로(‹)' 목적지를 지정.
            "1011": {
                "title": "비밀번호 변경",
                "url": "/m/setting/password",
                "parent": "1010"
            },
            "1020": {
                "title": "업체·장비·기사",
                "url": "/m/docs/v1"
            },
            "1021": {
                "title": "업체·장비·기사",
                "url": "/m/docs/v1"
            },
            "1030": {
                "title": "위치",
                "url": "/m/setting/gps"
            },


            "2000": {
                "title": "관리",
                "url": null
            },
            "2010": {
                "title": "거래처",
                "url": "/m/docs/v1"
            },
            "2020": {
                "title": "특차리스트",
                "url": "/m/relation/special"
            },
            "2030": {
                "title": "수발주제한",
                "url": "/m/relation/limit"
            },


            "3000": {
                "title": "충전금",
                "url": null
            },
            "3010": {
                "title": "충전",
                "url": "/m/account/deposit",
                "auth": ['수발주자']
            },
            "3011": {
                "title": "출금",
                "url": "/m/account/exchange"
            },
            // "3030": {
            //     "title": "입출금현황",
            //     "url": "/m/account/list",
            //     "auth": ['수발주자']
            // },
            // "3031": {
            //     "title": "사용내역(구버전)",
            //     "url": "/_sky__m_menu_setting_07.php?ontab=2"
            // },
            "3032": {
                "title": "사용내역",
                "url": "/m/cash/list"
            },


            "4000": {
                "title": "포인트",
                "url": null
            },
            "4010": {
                "title": "수주",
                "url": "/m/point"
            },
            "4020": {
                "title": "발주",
                "url": "/m/msix"
            },
            // 구 발주개수 페이지 — /m/msix 의 발주개수 탭으로 흡수(라우트는 리다이렉트로 유지)
            "4030": {
                "title": "발주개수",
                "url": "/m/msix?tab=odrcnt"
            },


            "5000": {
                "title": "장비대금 카드결제",
                "url": null
            },
            "5010": {
                "title": "결제",
                // 새 카드받기가 입구 — 페이앳 아이디가 있고 이노페이 승인 전이면 서버가 구 페이앳 화면(/m/card)으로 돌린다
                // (CardMerchantService::usesPayat). 구 화면 하단 [결제대행사 변경하기]가 다시 새 화면 가입으로 잇는다
                "url": "/m/cardpay"
            },
            "5011": {
                "title": "내역",
                "url": "/m/cardpay?tab=hist"   // 내역은 페이앳 회원도 새 화면(이전 페이앳 결제도 이관돼 있다)
            },


            "6000": {
                "title": "악덕업자",
                "url": null
            },
            "6010": {
                "title": "악덕알리미",
                "url": "/m/relation/devil"
            },


            "7000": {
                "title": "설정",
                "url": null
            },
            "7010": {
                "title": "환경설정",
                "url": "/m/setting/env",
                "auth": ['수발주자']
            },
            "7011": {
                "title": "소리설정",
                "url": "/m/setting/sound",
            },

            "8000": {
                "title": "고객지원",
                "url": null
            },
            "8010": {
                "title": "공지",
                "url": "/m/setting/notices"
            },
            // "8011": {
            //     "title": "장비불러!는",
            //     "url": "/_sky__m_menu_setting_board.php?tab=3"
            // },
            "8012": {
                "title": "고객센터",
                "url": "/m/setting/support"
            },
            // 약관 두 화면은 서랍에 없다(고객센터 하단 링크가 진입점) → parent 로 ✕ 목적지를 지정.
            // 서랍에서 온 게 아니라 햄버거는 감추고, ✕ 는 고객센터(8012)로 돌아간다.
            "8013": {
                "title": "이용약관",   // 서비스 · 위치 — 페이지 안에서 탭으로 가른다
                "url": "/m/setting/terms?t=1",
                "parent": "8012"
            },
            "8014": {
                "title": "처리방침",   // 개인정보 · 위치정보 — 페이지 안에서 탭으로 가른다
                "url": "/m/setting/terms?t=2",
                "parent": "8012"
            },
            "9000": {
                "title": "회원유형변경",
                "url": null
            },
            "9010": {
                "title": "회원유형변경",
                "url": "javascript:$j.F.Member.ModalCarOption.changeDriverType()",
                "auth": ['발주자']
            },

        };

    }
    /**
     * OLD-상단 영역을 출력한다.
     */
    showOldTopNav(){
        const self = this;
        const isMain = ( !G5['menuCode'] || G5['menuCode'].startsWith('M') );
        const item = G5['menuCode'] ? G5['MOBILE_MENU'][G5['menuCode']] : null;
        // 전체메뉴 페이지(/m/menu, page 모드)도 **대메뉴 바를 그대로 쓴다** — 메뉴를 여는 동안에도
        // 알림·수주·발주·일지·불러톡이 손 닿는 곳에 남아야 해서다. 시트는 그 아래에서 열린다
        // (_sidebar.scss 의 .jb-menu-page top). 제목·설정을 가진 시트 자기 헤더는 그대로 둔다.
        const isMenuPage = !!(item && item.isMenu);
        this._stampDepth(isMain);   // ✕ 가 몇 칸 되감을지 계산할 근거 — 전체메뉴는 대메뉴가 아니므로 isMain 그대로

        if( isMain || isMenuPage ) {// 메인 페이지(알림,수주,발주,일지) + 전체메뉴
            $('#main-menu-nav').prop('hidden', false);

            // 메인메뉴 : 수주,발주,일지 표시
            $('#main-menu-list li').each(function(){
                const code = $(this).data('code');
                if( !code ) return true; // 햄버거(코드없음)는 bindHeaderTap 의 #hdr-drawer 가 처리 → 스킵
                if( code=='M002' && MEMBER['mem_driver_type']!='수발주자') {
                    $(this).hide();
                    return true;//continue
                }
                if( code==G5['menuCode'] ) $(this).css('background','#fff2d5').addClass('t-current');// 다크 스타일 훅(라이트 배경은 인라인 유지)
                $(this).on('click',function(){
                    self.goMobileMenu(code);
                });
            });
            // 뱃지는 서버렌더 talk_cnt(개인 안읽음) 하나뿐이다 — 상담원이든 아니든 같다.
            // (구: 톡관리자는 checkNewChatMsg 가 read_by_admin 기준으로 덮어썼다. CS 처리가
            //  /ma 로 옮겨가며 그 폴링을 걷어냈다 — 여기 헤더 버튼은 이제 자기 불러톡으로 간다)
            let str = MEMBER['talk_cnt'];
            if( str>0 ) {
                $('#notyRoomTop').html(str).show();
            }
        }else{// 서브 페이지 ( 내정보, 환경설정, .. )
            $('#sub-menu-nav').show();
            // 서랍 같은 섹션의 형제 항목을 상단 탭으로 (예: 포인트 → 수주 | 발주)
            const sec = this.showSubTabs();
            if( G5['menuCode'] ) {
                // 형제탭이 있으면 제목은 섹션명(예: '포인트') — 항목명은 탭이 말한다
                const title = sec ? sec.title : (item ? item['title'] : '');
                $('#mobile-sub-menu-title').html(title || '');
            }
            // 좌측(구 뒤로가기 화살표) → 햄버거: 서랍 열기 / 우측 ✕(닫기) → 대메뉴로 나가기
            // 단, 서랍에 없는 하위 화면(parent 지정 — 약관 8013·8014, 비밀번호 변경 1011)은
            // '나가기(✕)' 가 아니라 '한 단계 돌아가기' 다 → 화살표를 왼쪽에 두고 ✕ 는 감춘다.
            //   hide() 가 아니라 visibility 로 감추는 이유: ul 이 space-between 이라 칸이 사라지면 제목이 밀린다.
            if( item && item.parent ){
                $('#top-back-btn1 i').removeClass('fa-bars').addClass('fa-chevron-left');
                $('#top-back-btn1').on('click', () => self.goBackOrParent(item.parent));
                $('#top-back-btn2').css('visibility', 'hidden');
            }else{
                // page 모드에선 이 버튼이 '전체메뉴 페이지로 이동'이므로 아이콘도 화살표가 맞다.
                // (overlay 모드는 같은 자리에 서랍이 겹쳐 뜰 뿐이라 햄버거를 유지한다 — 동작이 다르면 아이콘도 달라야 한다)
                if( this._isPageMode() ) $('#top-back-btn1 i').removeClass('fa-bars').addClass('fa-chevron-left');
                $('#top-back-btn1').on('click', () => self.openDrawer());
                $('#top-back-btn2').on('click', () => self.goMainMenu());
            }
        }
    }

    /**
     * 전체 서비스 목록(SVC_ORDER)·기본추천의 분기 기준 — 발주자 / 수발주자 소유자(사장) / 소속자(직원).
     * @returns {'baljoo'|'owner'|'staff'}
     */
    _memberKind(){
        const m = (typeof MEMBER !== 'undefined' && MEMBER) ? MEMBER : {};
        if( m.mem_driver_type !== '수발주자' ) return 'baljoo';
        return (+m.isOwnerAuth) ? 'owner' : 'staff';
    }

    /**
     * 상단 영역을 출력한다.
     */
    // showTopNav(){
    //     const self = this;
    //     if( !G5['menuCode'] || G5['menuCode'].startsWith('M') ) {// 메인 페이지(알림,수주,발주,일지 ..)
    //         $('#main-menu-nav').show();
    //
    //         // 메인메뉴 : 수주,발주,일지 표시
    //         $('#main-menu-list li').each(function(){
    //             const code = $(this).data('code');
    //             if( code=='M002' && MEMBER['mem_driver_type']!='수발주자') {
    //                 $(this).hide();
    //                 return true;//continue
    //             }
    //             if( code==G5['menuCode']) $(this).addClass('on');
    //             $(this).on('click',function(){
    //                 self.goMobileMenu(code);
    //             });
    //         });
    //         // 알림, 불러톡 버튼 표시
    //         $('#main-btn-list button').each(function(){
    //             const code = $(this).data('code');
    //             if(code=='M006'){// 불러톡 아이콘 그릴때 안읽은 숫자표시
    //                 let str = MEMBER['talk_cnt'];
    //                 // if( G5['menuCode']==code ) str=''; //현재페이지가 불러톡 페이지이면 숫자표시 안함
    //
    //                 if( str) {
    //                     $(this).find('span').html(str).show();
    //                 }else{
    //                     $(this).find('span').html(str).hide();
    //                 }
    //             }
    //
    //             if( code==G5['menuCode']) {// 해당메뉴가 선택될때 아이콘 변경
    //                 const onImg = $(this).data('on');
    //                 $(this).find('img').attr('src',onImg);
    //             }
    //             $(this).on('click',function(){
    //                 if( code=='M006' && MEMBER['isTalkAdmin'] ) {
    //                     location.href='/m/chat/room';
    //                     return;
    //                 }
    //                 self.goMobileMenu(code);
    //             });
    //         });
    //     }else{// 서브 페이지 ( 내정보, 환경설정, .. )
    //         $('#sub-menu-nav').show();
    //         if( G5['menuCode'] ) {
    //             const title = G5['MOBILE_MENU'][G5['menuCode']]['title'];
    //             // console.log('title',title);
    //             $('#mobile-sub-menu-title').html(title);
    //         }
    //         // 이전, 닫기 누르면 이동하기
    //         $('#top-back-btn1, #top-back-btn2').on('click',function(){
    //             if( G5['menuCode']=='1021' ) {
    //                 history.back();
    //                 return;
    //             }
    //             self.goMobileMenu('M000');// sitemap
    //         })
    //     }
    //
    //     /**
    //      * 상단영역이 흰색인데 본문영역도 흰색일경우
    //      * 스크롤을 내리면 구분이 애매해진다. 그래서 경계선을 동적으로 넣기위한 기능이다.
    //      */
    //     $(window).scroll(function () {
    //         const headerContainer = $('#main-menu-nav, #sub-menu-nav');
    //         const scrollTop = $(window).scrollTop();
    //         if (scrollTop > 0) {
    //             headerContainer.css('borderBottom', '0.5px solid #ccc');
    //         } else {
    //             headerContainer.css({
    //                 'borderBottom': 'none',
    //                 'boxShadow': 'none'
    //             });
    //         }
    //     });
    // }

    /**
     * 서브메뉴를 출력한다.
     */
    showMobileSubMenu(){
        // const $el = $('#tab-menu-container');
        // // 대메뉴인 경우
        // if( !G5['menuCode'] || G5['menuCode'].startsWith('M') ) {
        //     $el.hide();
        //     return;
        // }
        // const $ul = $el.find('ul');
        // $.each(G5['MOBILE_MENU'], function(code,row){
        //     // 대중 메뉴에 속하는지
        //     if( G5['menuCode'].substring(0,3)!=code.substring(0,3) ) return true; // continue
        //     // 대메뉴는 스킵
        //     if( code.substring(2,4)=='00') return true; // continue
        //     // 권한체크
        //     if(row['auth'] && !row['auth'].includes(MEMBER['mem_driver_type'])) return true;// continue;
        //     // console.log(code,code.substring(2,4));
        //     let cls='';
        //     if( G5['menuCode']==code ) cls='on';
        //     // console.log( G5['menuCode'], code, cls)
        //     $ul.append(`<li><a href="${row['url']}" class="${cls}">${row['title']}</a></li>`);
        // });
    }

    /**
     * 서브 페이지 헤더 ✕ — '한 칸 뒤로'가 아니라 서브 흐름 전체를 닫고 대메뉴로 나간다.
     *
     * 서랍을 거듭 열어 A→B→C 로 들어간 뒤 ✕ 를 누르면, 한 칸씩 되짚는 게 아니라
     * 들어오기 전 대메뉴(알림·수주·발주·일지)로 한 번에 돌아가는 것이 사용자의 기대다.
     * 깊이(_stampDepth)만큼 되감으므로 대메뉴는 새로 로드되지 않고 보던 상태 그대로 복귀하며,
     * 지나온 서브 페이지들은 히스토리 앞쪽으로 밀려 하드웨어 백버튼에도 다시 나오지 않는다.
     * 되감을 항목이 없으면(딥링크·앱 콜드스타트) 마지막 대메뉴 주소로, 그것도 없으면 알림으로.
     */
    goMainMenu(){
        const st = history.state || {};
        // 깊이의 정본은 이 항목에 찍힌 값(뒤로가기·bfcache 복원에도 살아남는다). 없을 때만 세션값.
        const depth = (typeof st.jbDepth === 'number') ? st.jbDepth
                                                      : (parseInt(this._ssGet('jbDepth') || '0', 10) || 0);
        const steps = Math.min(depth, history.length - 1);   // 세션 시작보다 더 뒤로는 못 간다
        if( steps > 0 ){ history.go(-steps); return; }

        const home = this._ssGet('jbMainUrl') || (G5['MOBILE_MENU']['M001'] || {}).url || '/';
        $('#PageMoveLoading').show();
        location.replace(home);
    }

    /**
     * 히스토리 깊이를 현재 항목에 찍는다 — 대메뉴=0, 서랍으로 들어간 서브=1, 그 아래=2 …
     *
     * history.state 에 찍어두는 이유: 뒤로가기로 되돌아온 항목은 값이 그대로 살아나 깊이가
     * 어긋나지 않는다. (sessionStorage 카운터만 쓰면 뒤로가기 때 줄지 않아 계속 커진다)
     * @param isMain 대메뉴(알림·수주·발주·일지) 여부
     */
    _stampDepth(isMain){
        const st = history.state || {};
        let depth;
        if( this._isMain === undefined ){
            this._isMain = isMain;
            // bfcache(뒤로가기 복원)는 스크립트를 다시 돌리지 않아 세션에 남은 깊이가 낡는다 → 복원 때 재동기화
            window.addEventListener('pageshow', (e) => { if( e.persisted ) this._stampDepth(this._isMain); });
        }
        if( isMain ){
            depth = 0;
            this._ssSet('jbMainUrl', location.pathname + location.search);   // ✕ 폴백 목적지
        } else if( typeof st.jbDepth === 'number' ){
            depth = st.jbDepth;                                              // 이미 찍힌 항목으로 복귀
        } else {
            const prev = parseInt(this._ssGet('jbDepth') || '0', 10) || 0;
            // goParentMenu 처럼 location.replace 로 온 이동은 히스토리 항목 수가 그대로다 → 깊이 유지
            depth = (this._ssGet('jbReplaced') === '1') ? Math.max(prev, 1) : prev + 1;
        }
        this._ssSet('jbReplaced', '');
        try { history.replaceState(Object.assign({}, st, { jbDepth: depth }), ''); } catch(e){}
        this._ssSet('jbDepth', String(depth));
    }

    /** sessionStorage 접근 — $j.Common.Store.session(try/catch 내장) 위임. 빈 문자열은 삭제. */
    _ssGet(key){ return $j.Common.Store.session.get(key); }
    _ssSet(key, val){ val === '' ? $j.Common.Store.session.remove(key) : $j.Common.Store.session.set(key, val); }

    /**
     * 서브 페이지 상단 형제탭을 그린다 — 서랍의 '같은 섹션' 항목을 탭으로 (예: 포인트 → 수주 | 발주).
     * 서랍을 열지 않고도 옆 화면으로 바로 갈 수 있게 하는 것이 목적.
     * @returns {object|null} 그렸으면 {title, items, code}, 형제가 없으면 null
     */
    showSubTabs(){
        const sec = this._subTabSection(G5['menuCode']);
        const $bar = $('#sub-tab-nav');
        if( !sec || !$bar.length ) return null;

        const html = sec.items.map((it) => {
            const cls = (it.code === sec.code) ? 'on' : '';
            return `<li><a href="javascript:void(0)" class="${cls}" data-code="${it.code}">${this._esc(it.tab || it.label)}</a></li>`;
        }).join('');
        $bar.find('ul').html(html);

        // 헤더 줄(제목 'MY' + ✕)을 접고 '‹ + 탭' 한 줄로 합친다.
        // 제목이 섹션명('MY')이라 탭의 '내정보'와 같은 말을 두 번 하고 있었다 — 탭이 이미 어디인지 말한다.
        // ‹ 의 목적지는 헤더 좌측 버튼과 같다(page 모드 = 전체메뉴) — 동선은 그대로 두고 자리만 옮겼다.
        $bar.find('.jb-subtab-back').remove();
        $('<button type="button" class="jb-subtab-back" aria-label="뒤로"><i class="fas fa-chevron-left" aria-hidden="true"></i></button>')
            .on('click', () => this.openDrawer())
            .prependTo($bar);
        $('#sub-menu-nav').hide();

        $bar.prop('hidden', false);
        // has-subtab: 본문을 탭바 높이만큼 내린다 / subtab-merged: 헤더 줄을 접는다 (_subtab.scss)
        document.body.classList.add('has-subtab', 'subtab-merged');

        $bar.off('click', 'a').on('click', 'a', (e) => {
            const code = String($(e.currentTarget).data('code'));
            if( code === sec.code ) return;                  // 현재 탭
            const item = G5['MOBILE_MENU'][code];
            if( !item || !item.url ) return;
            $('#PageMoveLoading').show();
            // 탭 전환도 히스토리를 쌓는다 — 뒤로가기가 '직전에 보던 탭'으로 돌아가야 하기 때문.
            // (깊이도 함께 늘어 ✕ 는 여전히 한 번에 대메뉴로 나간다 — _stampDepth)
            location.href = item.url;
        });
        return sec;
    }

    /**
     * 현재 메뉴코드가 속한 서랍 섹션을 찾는다.
     * 탭이 의미 있으려면 형제가 2개 이상이어야 하므로 그 외에는 null.
     */
    _subTabSection(menuCode){
        if( !menuCode ) return null;
        const code = SUBTAB_ALIAS[menuCode] || menuCode;
        const found = this._drawerSections().find((s) => s && s.items
            && s.items.filter(Boolean).some((it) => it.code === code));
        if( !found ) return null;
        const items = found.items.filter(Boolean).filter((it) => it.code); // href 전용(외부앱 등)은 탭 제외
        if( items.length < 2 ) return null;
        return { title: found.head || found.title, items, code };          // head: 헤더가 좁을 때 쓰는 짧은 제목
    }

    /**
     * 좌측 서랍(햄버거) 열기.
     * 닫기: 배경(dim) 탭 · 왼쪽으로 스와이프 · ✕ · 하드웨어 뒤로가기.
     * 메뉴 항목으로 이동할 때의 처리는 모드에 따라 갈린다 — _isPageMode / goMobileMenu 참조.
     */
    openDrawer(){
        // page 모드: 서랍은 주소를 가진 페이지다 — 오버레이를 띄우지 않고 그리로 간다.
        // 전체메뉴 페이지도 대메뉴 바를 그대로 쓰므로 거기서 햄버거를 또 누를 수 있다 → 자기 자신 재진입 차단.
        if( this._isPageMode() ){
            if( location.pathname === MENU_PAGE_URL ) return;
            $('#PageMoveLoading').show();
            location.href = MENU_PAGE_URL;
            return;
        }
        if( !this._openDrawerUI() ) return;
        // overlay 모드: 하드웨어 뒤로가기로 '서랍만' 닫으라고 항목을 하나 쌓는다.
        // (goMobileMenu 가 메뉴로 이동할 때 이 항목을 목적지로 대체한다)
        try { history.pushState({ jbDrawer: 1 }, ''); this._drawerPushed = true; } catch(e){}
    }

    /**
     * 서랍 오버레이 UI 를 연다(히스토리는 건드리지 않는다). overlay 모드 전용.
     * @returns {boolean} 새로 열었으면 true, 마크업이 없거나 이미 열려 있으면 false
     */
    _openDrawerUI(){
        const $d = $('#jbDrawer');
        if( !$d.length ) return false;

        // 최초 1회: 내용 JS 렌더 + 닫기 핸들러 + 뒤로가기(popstate) 바인딩
        if( !this._drawerBound ){
            this._drawerBound = true;
            const panel = $d.find('.jb-drawer-panel')[0];
            this.renderMenu(panel, true);                            // 프로필 포함 (사용기록은 동기 읽기라 한 번에 그려진다)
            $d.on('click', '.jb-drawer-dim', () => this.closeDrawer());
            this._bindDrawerSwipe(panel);
            window.addEventListener('popstate', this._onDrawerPop);  // 하드웨어 뒤로가기 → 서랍 닫기
        }

        if( $d.hasClass('is-open') ) return false;
        document.body.classList.add('drawer-open');
        $d.addClass('is-open').attr('aria-hidden', 'false');
        return true;
    }

    /** 서랍이 '가는 곳'인가(page) '떠 있는 표면'인가(overlay) — 파일 상단 DRAWER_MODE 참조. */
    _isPageMode(){ return DRAWER_MODE === 'page'; }


    /** ✕·스와이프·배경탭 → 쌓아둔 history 를 되감아 닫는다(popstate 가 UI 정리). */
    closeDrawer(){
        if( this._drawerPushed ){ this._drawerPushed = false; history.back(); return; }
        this._closeDrawerUI();
    }

    /** 하드웨어/브라우저 뒤로가기: 서랍이 열려 있으면 페이지 이동 대신 서랍만 닫는다. */
    _onDrawerPop = () => {
        if( $('#jbDrawer').hasClass('is-open') ){ this._drawerPushed = false; this._closeDrawerUI(); }
    };

    _closeDrawerUI(){
        $('#jbDrawer').removeClass('is-open').attr('aria-hidden', 'true');
        document.body.classList.remove('drawer-open');
    }

    /** 패널을 왼쪽으로 밀면 닫기(가로 우세 제스처만, 세로 스크롤은 양보). */
    _bindDrawerSwipe(panel){
        if( !panel ) return;
        let sx = 0, sy = 0, dx = 0, active = false, decided = false;

        panel.addEventListener('touchstart', (e) => {
            if( e.touches.length !== 1 ){ active = false; return; }
            sx = e.touches[0].clientX; sy = e.touches[0].clientY;
            dx = 0; active = true; decided = false;
            panel.style.transition = 'none';
        }, { passive: true });

        panel.addEventListener('touchmove', (e) => {
            if( !active ) return;
            const mx = e.touches[0].clientX - sx;
            const my = e.touches[0].clientY - sy;
            if( !decided ){
                if( Math.abs(mx) < 6 && Math.abs(my) < 6 ) return;
                decided = true;
                if( Math.abs(mx) <= Math.abs(my) ){ active = false; panel.style.transition = ''; return; } // 세로 → 스크롤 양보
            }
            dx = Math.min(0, mx);                 // 왼쪽으로만
            panel.style.transform = `translateX(${dx}px)`;
            if( dx < 0 ) e.preventDefault();
        }, { passive: false });

        const end = () => {
            if( !active ) return;
            active = false;
            panel.style.transition = '';
            panel.style.transform = '';           // 인라인 제거 → CSS(.is-open 유무)로 복귀/닫힘
            if( dx < -70 ) this.closeDrawer();
        };
        panel.addEventListener('touchend', end, { passive: true });
        panel.addEventListener('touchcancel', end, { passive: true });
    }

    /**
     * '전체 서비스' 메뉴를 JS 로 렌더한다. (좌측 서랍 + /m/setting 사이트맵 공용)
     * @param target        선택자 문자열 또는 DOM 엘리먼트
     * @param withProfile   true 면 상단 프로필 블록 포함(서랍용)
     */
    renderMenu(target, withProfile = false){
        const el = (typeof target === 'string') ? document.querySelector(target) : target;
        if( !el ) return;

        if( withProfile ){
            // 서랍(오버레이): 상단 헤더(프로필+닫기 한 줄, 고정) + 스크롤 영역
            //   제목은 격자 안에 둔다 — 헤더 자리를 프로필 인사말이 이미 쓰고 있다.
            el.innerHTML =
                `<div class="jb-drawer-head">`
              + this._profileHtml()
              + `<button type="button" class="jb-drawer-close" aria-label="닫기" onclick="$j.F.Mobile.Layout.closeDrawer()">✕</button>`
              + `</div>`
              + `<div class="jb-drawer-scroll"><div class="jb-svc">${this._menuGridHtml({ title: true })}</div></div>`;
        }else{
            // /m/menu: 대메뉴 바 아래를 덮는 시트 — 제목·설정을 가진 자기 헤더를 쓴다.
            // 손잡이(회색 알약)는 두지 않는다 — 끌어서 닫히지 않는데 끌 수 있는 것처럼 보인다.
            el.innerHTML =
                this._sheetHeadHtml()
              + `<div class="jb-sheet-body"><div class="jb-svc">${this._menuGridHtml({ card: true })}</div></div>`;
        }
        this._bindMenu(el);
    }

    /**
     * 전체메뉴 시트 닫기 — '한 칸 뒤로'다.
     * 시트를 열 때 히스토리를 한 칸 쌓았으므로 그 한 칸을 되감으면 열기 전 화면으로 돌아간다.
     * 딥링크·새로고침으로 바로 들어와 되감을 곳이 없으면(깊이 0) 대메뉴로 나간다.
     * (헤더 ✕ 는 뺐지만 동작은 남긴다 — data-act="close" 로 언제든 다시 붙일 수 있다)
     *
     * ⚠ 닫힘 애니메이션은 두지 않는다. 페이지 방식이라 시트 뒤에 이전 화면이 없어서,
     *   내려가는 동안 드러나는 건 이전 화면이 아니라 이 페이지의 빈 바탕이다.
     *   (뒤 화면이 드러나려면 같은 문서 안 오버레이여야 한다 — DRAWER_MODE 참조)
     */
    closeMenuPage(){
        const st = history.state || {};
        if( typeof st.jbDepth === 'number' && st.jbDepth > 0 && history.length > 1 ){
            history.back();
            return;
        }
        this.goMainMenu();
    }

    /**
     * 전체 서비스 격자의 이벤트 — 아코디언 토글 · 항목 이동 · 사용기록 적립.
     * 항목이 <a href> 가 아니라 버튼인 이유: 이동 직전에 사용기록을 남겨야 하고(칩 순위),
     * 소메뉴 헤더와 같은 행 구조를 공유하기 때문이다.
     */
    _bindMenu(root){
        const $root = $(root);

        // 아코디언 — 소메뉴 헤더 탭. max-height 를 실측해서 애니메이션한다.
        //
        // ⚠ 실측 px 은 **애니메이션이 도는 동안만** 물린다. 끝나면 none 으로 푼다.
        //   글자크기 3단계는 body 에 zoom 을 걸어(base/_fontsize.scss) 레이아웃 px 자체를 바꾼다.
        //   항목행은 fs-fixed(54px) 라 보통에서 54, 아주크게에서 38.6 레이아웃px 이 된다 — 즉
        //   아주크게에서 잰 값을 붙여둔 채 보통으로 내리면 상자가 옛 높이에 갇혀 아래 항목이
        //   overflow:hidden 에 잘린다. 열려 있는 칸은 내용만큼 자라야 어느 단계에서도 안 잘린다.
        $root.off('click', '.jb-svc-head').on('click', '.jb-svc-head', (e) => {
            const $g = $(e.currentTarget).closest('.jb-svc-group');
            const $b = $g.find('.jb-svc-body');
            if( !$b.length ) return;
            if( !$g.hasClass('is-fold') ){
                $b.css('max-height', $b[0].scrollHeight + 'px');
                requestAnimationFrame(() => { $g.addClass('is-fold'); $b.css('max-height', '0px'); });
            }else{
                $g.removeClass('is-fold');
                $b.css('max-height', $b[0].scrollHeight + 'px');
                this._unlockSvcBody($b);
            }
            $(e.currentTarget).attr('aria-expanded', $g.hasClass('is-fold') ? 'false' : 'true');
        });
        // 헤더는 div[role=button] 이라 Enter/Space 를 직접 받아야 한다 (항목·칩은 <button> 이라 불필요)
        $root.off('keydown', '.jb-svc-head').on('keydown', '.jb-svc-head', (e) => {
            if( e.key !== 'Enter' && e.key !== ' ' ) return;
            e.preventDefault();
            $(e.currentTarget).trigger('click');
        });

        // 시트 헤더의 '그 자리에서 끝나는' 동작 — 밝기·글자크기·닫기.
        // (톱니는 이동이라 data-code 로 아래 핸들러가 맡는다)
        $root.off('click', '[data-act]').on('click', '[data-act]', (e) => {
            const act = String($(e.currentTarget).data('act'));
            if( act === 'close' ){ this.closeMenuPage(); return; }

            const T = ($j.F && $j.F.Mobile && $j.F.Mobile.Theme) || null;
            if( !T ) return;

            if( act === 'theme' ){
                // 기준은 선호값(auto 포함)이 아니라 **지금 화면에 걸린 값**이다 — 눈에 보이는 것의 반대로
                // 뒤집혀야 '지금 밝으니 어둡게'가 성립한다. auto 였다면 이 순간 light|dark 로 굳는다.
                T.setTheme(T.getTheme() === 'dark' ? 'light' : 'dark');
                return;
            }
            if( act === 'fontsize' ){
                // 버튼이 하나뿐이라 아주크게 다음은 보통으로 돌아온다(Theme.stepFontSize 는 양끝에서 멈춘다).
                const i = SHEET_FS.indexOf(T.getFontSizePref());
                const next = SHEET_FS[((i < 0 ? 0 : i) + 1) % SHEET_FS.length];
                T.setFontSize(next);
                if( $j.Ui && $j.Ui.Toast ) $j.Ui.Toast.show(`글자 크기 ${SHEET_FS_LABEL[next]}`);
            }
        });

        // 항목·칩 이동. 코드 없는 진입점(외부앱 등)은 <a href> 로 그려지므로 여기 걸리지 않는다.
        // 사용기록은 여기서 세지 않는다 — 도착한 화면이 스스로 센다(markMenuVisit).
        $root.off('click', '[data-code]').on('click', '[data-code]', (e) => {
            this.goMobileMenu(String($(e.currentTarget).data('code')));
        });

        // 처음부터 펼쳐진 소메뉴는 아예 재지 않는다 — 접을 때 그 자리에서 실측하면 되고,
        // 미리 박아두면 글자크기 단계를 바꾼 뒤 그 값이 옛 레이아웃 px 이 된다(위 ⚠).
        $root.find('.jb-svc-group:not(.is-fold) .jb-svc-body').css('max-height', '');
    }

    /**
     * 펼침 애니메이션이 끝나면 실측 px 을 푼다 — 이후 내용·글자크기가 바뀌어도 칸이 따라 자란다.
     * transitionend 를 못 받는 경우(탭 비활성 등)를 대비해 같은 시간의 타이머로도 한 번 더 푼다.
     */
    _unlockSvcBody($b){
        const el = $b[0];
        if( !el ) return;
        const off = () => {
            el.removeEventListener('transitionend', off);
            // 그새 다시 접혔으면 손대지 않는다 (접힘은 !important 0 이라 무해하지만 상태를 흔들지 않는다)
            if( !$b.closest('.jb-svc-group').hasClass('is-fold') ) $b.css('max-height', '');
        };
        el.addEventListener('transitionend', off);
        setTimeout(off, 300);   // .jb-svc-body 의 transition 250ms + 여유
    }

    _esc(s){
        return String(s == null ? '' : s)
            .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
            .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
    }

    _profileHtml(){
        const m = (typeof MEMBER !== 'undefined' && MEMBER) ? MEMBER : {};
        // 이름은 기사명(mem_name)이다 — 본인인증 실명(real_name)은 내정보 계정 카드가 정본이라,
        // 여기서 실명을 앞세우면 같은 사람 이름이 서랍과 내정보에서 갈린다.
        const name = m.mem_name || '';
        const img  = this._esc(m.profileImg || '/img/profile_img_man.png');
        const greet = (m.mem_driver_type === '수발주자')
            ? '오늘도 안전작업 하세요!'
            : '항상 감사드리며 최선을 다하겠습니다!';

        return `<div class="jb-drawer-profile" onclick="$j.F.Mobile.Layout.goMobileMenu('1010')">
            <img class="jb-drawer-avatar" src="${img}" alt="프로필">
            <div class="jb-drawer-who">
                <p class="jb-drawer-greet"><strong>${this._esc(name)}</strong> 님, ${greet}</p>
            </div>
        </div>`;
    }

    /**
     * @param opt.title 격자 안에 '전체 서비스' 제목을 넣을지 — 서랍(오버레이)만 true.
     *                  /m/menu 는 시트 헤더가 제목을 갖고 있어 중복이다.
     * @param opt.card  'MY' 그룹(내정보·서류등록·위치)을 목록 맨 위에 둘지 — /m/menu 시트만 true.
     *                  서랍(오버레이)은 고정 헤더에 이미 프로필 줄을 갖고 있다(_profileHtml).
     */
    _menuGridHtml(opt = {}){
        // 구조를 만드는 곳은 여기 한 곳뿐이다 — 'line'·empty 같은 2단 격자 시절의 자리표시자는
        // 세로 리스트에서 의미가 없으므로 걷어낸다.
        const all = this._drawerSections()
            .filter((s) => s && s !== 'line' && !s.empty)
            .map((s) => Object.assign({}, s, { items: (s.items || []).filter(Boolean) }))
            .filter((s) => s.items.length);

        // 목록으로 그릴 것만 회원유형별 순서로 추린다(SVC_ORDER).
        // 앱마켓 심사용 계정(G5.STORE_TEST, /adm/config)에게는 「악덕업자」를 아예 그리지 않는다 — 다른 스토어(원스토어)로
        // 이어지는 화면을 심사자가 보지 않게. 서랍(오버레이)과 /m/menu 가 모두 여기서 그려지므로 이 한 곳이면 된다.
        let order = SVC_ORDER[this._memberKind()] || [];
        if (G5['STORE_TEST']) order = order.filter((t) => t !== '악덕업자');
        const shown = all
            .filter((s) => order.indexOf(s.title) >= 0)
            .sort((a, b) => order.indexOf(a.title) - order.indexOf(b.title));

        // 'MY' 는 SVC_ORDER 에 없어(프로필 카드였던 시절의 흔적) shown 에 안 잡힌다 — 순서와 무관하게
        // 항상 맨 위에, 다른 소메뉴와 같은 모양(제목 'MY' + 아코디언 본문)으로 직접 붙인다.
        // 항목이 1개뿐인 회원유형(업체발주자)은 _sectionHtml 규칙대로 헤더 없이 단독 항목이 된다.
        const myGroup = all.find((s) => s.title === 'MY');
        return (opt.title ? `<h2 class="jb-svc-title">전체 서비스</h2>` : '')
             + (opt.card && myGroup ? this._sectionHtml(myGroup) : '')
             + shown.map((s) => this._sectionHtml(s)).join('')
             + this._toolsHtml()
             // 목록 끝의 로그아웃 — 서랍과 /m/menu 양쪽이 이 한 곳에서 그려진다.
             // 여기가 로그아웃의 정본이다(내정보 푸터에는 두지 않는다).
             + `<div class="jb-svc-logout"><button type="button" class="jb-logout" onclick="$j.F.Mobile.Layout.askLogout()">로그아웃</button></div>`;
    }

    /**
     * 시트 헤더 — 제목 '전체' + 톱니(환경설정) · 달(밝기) · 가(글자크기).
     *
     * 톱니는 data-code 라 다른 메뉴 항목과 같은 경로(_bindMenu → 사용기록 + 이동)를 탄다.
     * 나머지 둘은 이동이 아니라 이 자리에서 끝나는 동작이므로 data-act 로 가른다.
     *
     * ✕(닫기) 버튼은 빼 뒀다 — 대메뉴 바가 이 화면에도 계속 떠 있어(showOldTopNav) 나가는 길이
     * 이미 상단에 있다. 남은 셋이 ✕ 자리까지 오른쪽으로 밀린다(.jb-sheet-acts 가 우측정렬).
     */
    _sheetHeadHtml(){
        const ic = (k, cls) => `<svg class="jb-sheet-ic${cls ? ' ' + cls : ''}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${SHEET_ICON[k]}</svg>`;

        // 구 data-dark-ok 게이트는 폐지됐다 — 다크는 전체 오픈(2026-08-11)이고, 이제 선호값이 기기
        // (localStorage)에 있어 서버가 막을 수단도 대상도 없다. 밝기 버튼은 항상 그린다.
        return `<div class="jb-sheet-head">`
             +   `<div class="jb-sheet-title">전체</div>`
             +   `<div class="jb-sheet-acts">`
             +     `<button type="button" class="jb-sheet-act" data-code="7010" aria-label="환경설정">${ic('gear')}</button>`
             +     `<button type="button" class="jb-sheet-act" data-act="theme" aria-label="화면 밝기 전환">${ic('moon', 'jb-sheet-moon')}</button>`
             +     `<button type="button" class="jb-sheet-act jb-sheet-fs" data-act="fontsize" aria-label="글자 크기 바꾸기">가</button>`
             +   `</div>`
             + `</div>`;
    }

    /**
     * 내부용 '도메인 변경' — 개발 브릿지(/m/dev/bridge)로 가는 유일한 진입점.
     *
     * 노출 조건은 구 다크모드 오픈베타와 같은 규칙이다(다크는 2026-08-11 전체 오픈으로 풀렸다):
     *   개발환경(G5.isDebug = .env APP_DEBUG)은 전원 · 운영은 베타테스터 명단만
     *   (MEMBER.isBetaTester ← g5_config.beta_users, /adm/config 에서 편집).
     * 회원유형과 무관하므로 _drawerSections() 가 아니라 여기서 붙인다 —
     * 섹션에 넣으면 '관리' 같은 실제 소메뉴에 섞인다.
     * 코드가 없는 <a href> 라 사용기록(칩) 집계 대상도 아니다.
     *
     * ⓘ 여기 '관리자(모바일 관리 → /ma)' 항목이 함께 있었으나 뺐다.
     *   같은 곳으로 가는 옆구리 알약($j.F.Mobile.SiteSwitch)이 생겨 한 번 누르면 넘어간다 —
     *   알약이 있는데 서랍 맨 아래까지 스크롤하는 길을 남겨두면 출구가 둘로 갈린다.
     *   /ma 진입 판정(SiteSwitch.canEnter)을 쓰는 곳은 이제 알약과 불러톡 아이콘 둘이다.
     *   남은 항목이 이것 하나뿐이라 _sectionHtml 이 '내부도구' 헤더 없이 단독 항목으로 그린다.
     */
    _toolsHtml(){
        if( !this._isInsider() ) return '';
        return this._sectionHtml({
            title: '내부도구',   // 아이콘 대역용 — 단독 항목이라 이 이름이 화면에 뜨지는 않는다
            items: [{ label:'도메인 변경', sub:'(개발용)', href: DEV_BRIDGE_URL }],
        });
    }

    /** 내부자(개발환경 전원 · 운영은 베타테스터 명단)인가 — 내부용 메뉴 노출 판정. */
    _isInsider(){
        if( typeof G5 !== 'undefined' && G5 && G5.isDebug ) return true;
        return !!(typeof MEMBER !== 'undefined' && MEMBER && +MEMBER.isBetaTester);
    }

    /**
     * 소메뉴 한 덩어리. 항목이 1개뿐이면 헤더 없는 '단독 항목'으로 — 접을 게 없는데
     * 헤더+본문 2줄을 쓰면 목록만 길어진다(악덕업자 등).
     */
    _sectionHtml(sec){
        const ic = SVC_ICON[sec.title] || {};
        if( sec.items.length === 1 ){
            return `<div class="jb-svc-solo">${this._svcItemHtml(sec.items[0], sec)}</div>`;
        }
        const head = `<div class="jb-svc-head" role="button" tabindex="0" aria-expanded="true">`
                   + `<span class="jb-svc-ic tone-${ic.tone || 'gray'}" aria-hidden="true">${this._svgIcon(ic.path)}</span>`
                   + `<span class="jb-svc-name">${this._esc(sec.head || sec.title)}</span>`
                   + `<svg class="jb-svc-caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>`
                   + `</div>`;
        const body = sec.items.map((it) => this._svcItemHtml(it)).join('');
        return `<div class="jb-svc-group">${head}<div class="jb-svc-body">${body}</div></div>`;
    }

    /**
     * 항목 한 줄. sec 를 주면 '단독 항목'(섹션 아이콘 + 굵게), 없으면 소메뉴 하위(들여쓰기).
     * 이름은 어느 쪽이든 항목 라벨을 쓴다 — 섹션명을 쓰면 1개짜리 MY 섹션이 '내정보'가 아니라
     * 'MY' 로 나오는 식으로 어긋난다. 섹션에서 가져오는 건 아이콘뿐이다.
     * 코드가 없는 항목(외부앱 진입 등)은 <a href> 그대로 — 사용기록 대상도 아니다.
     */
    _svcItemHtml(it, sec = null){
        const ic    = sec ? (SVC_ICON[sec.title] || {}) : null;
        const sub   = it.sub ? `<span class="jb-svc-sub">${this._esc(it.sub)}</span>` : '';
        // 이름+부제를 .jb-svc-lb 로 싼다 — 안 싸면 .jb-svc-left 의 flex gap 이 둘 사이까지 벌린다
        // 굵기는 소메뉴 헤더(800)보다 한 단 아래인 700 이다(.is-top) — 단독 항목은 '헤더처럼 보이는
        // 항목'이 아니라 '아이콘 달린 항목'이라, 헤더와 같은 무게면 목록에서 층이 사라진다.
        const tag = it.app ? `<span class="jb-move-tag">앱 이동</span>` : '';
        const inner = `<span class="jb-svc-left">`
                    + (ic ? `<span class="jb-svc-ic tone-${ic.tone || 'gray'}" aria-hidden="true">${this._svgIcon(ic.path)}</span>` : '')
                    + `<span class="jb-svc-lb">${this._esc(it.label)}${sub}</span>${tag}</span>`
                    // 오른쪽 표식은 **소메뉴 레벨(단독 항목)에만** 붙인다. 하위 항목까지 달면
                    // 한 카드 안에서 꺾쇠가 줄마다 반복돼 아코디언 캐럿(˅)과 뒤섞인다.
                    //   앱 이동(↗) — 이 앱을 떠난다 / 꺾쇠(›) — 앱 안에서 간다
                    + (sec ? `<span class="jb-svc-right">${it.app ? this._svcExtIcon() : this._svcChevron()}</span>` : '');
        const cls = `jb-svc-item ${sec ? 'is-top' : 'is-sub'}`;
        return it.code
            ? `<button type="button" class="${cls}" data-code="${it.code}">${inner}</button>`
            : `<a class="${cls}" href="${it.href}">${inner}</a>`;
    }

    /** 소메뉴 레벨 항목의 '간다' 표식 — 아코디언 캐럿(˅)과 방향으로 구분된다. */
    _svcChevron(){
        return `<span class="jb-svc-chev" aria-hidden="true">`
             + `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${SHEET_ICON.go}</svg></span>`;
    }

    /** 앱 밖으로 나가는 항목(악덕알리미 등)의 표식 — 꺾쇠 대신 이것만 쓴다. */
    _svcExtIcon(){
        return `<span class="jb-svc-ext" aria-hidden="true">`
             + `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">`
             + `<path d="M15 3h6v6"/><path d="M10 14 21 3"/>`
             + `<path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/></svg></span>`;
    }

    /** 아이콘 path → SVG. 색은 currentColor 라 tone-* 클래스가 정한다. */
    _svgIcon(path){
        return `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${path || ''}</svg>`;
    }

    /** 사용기록 읽기 — {메뉴코드: {c:횟수, t:마지막시각(unixtime)}}. */
    _menuUse(){
        return $j.Common.Store.local.getJSON(this._useKey(), {}) || {};
    }

    /** 사용기록 저장 키 — 회원별. 회원번호를 모르면(비로그인 등) 0 칸을 쓴다. */
    _useKey(){
        return USE_KEY_PRE + (((typeof MEMBER !== 'undefined' && MEMBER) ? MEMBER.num : 0) || 0);
    }

    /**
     * 이 화면에 도착한 것을 사용기록에 적립 — 매 페이지 1회(Sites/Mobile/Bootstrap).
     *
     * 전에는 전체 서비스에서 '고를 때'만 셌다. 그러면 충전(3010)으로 들어와 화면 안 형제탭으로
     * 사용내역(3032)을 눌러도 3010 만 남아, 정작 오래 본 화면이 기록에서 빠졌다.
     * **도착지에서 세면** 어느 경로로 왔든(서랍·칩·형제탭·화면 안 버튼·딥링크) 한 번씩 같은 규칙으로 셈해진다.
     */
    markMenuVisit(){
        const code = this._visitCode(G5['menuCode']);
        if( code ) this._bumpMenuUse(code);
    }

    /**
     * 이번 도착을 셀 것인지 판정하고 셀 코드를 돌려준다(안 세면 빈 문자열).
     *
     * 세지 않는 것:
     *   - 서랍에 없는 코드 — 대메뉴 탭줄(M001·0101 등)·전체메뉴(0000). 칩으로 그릴 수 없는 자리라 세도 죽은 행이다
     *   - 새로고침·뒤로가기 — 그 메뉴를 '고른' 것이 아니다. 뒤로가기까지 세면 왕복이 잦은 화면이 부풀려진다
     * 형제탭 별칭(1021·4030)은 서랍 코드로 접어 넣는다 — 칩 이름표(_recentMeta)가 서랍 코드로만 만들어진다.
     */
    _visitCode(raw){
        const code = SUBTAB_ALIAS[raw] || String(raw || '');
        if( !code || this._navType() !== 'navigate' ) return '';
        const found = this._drawerSections().some((s) => s && s.items
            && s.items.filter(Boolean).some((it) => it.code === code));
        return found ? code : '';
    }

    /** 이 페이지에 온 방식 — 'navigate' | 'reload' | 'back_forward'. 못 알아내는 구 웹뷰는 navigate 로 본다. */
    _navType(){
        try{
            const nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || null;
            if( nav && nav.type ) return nav.type;
            const legacy = performance.navigation && performance.navigation.type;   // 구 API: 0 이동 1 새로고침 2 뒤로
            if( legacy === 1 ) return 'reload';
            if( legacy === 2 ) return 'back_forward';
        }catch(e){}
        return 'navigate';
    }

    /**
     * 사용기록 적립 — 해당 코드 +1, 마지막시각 갱신. 오래 안 쓴 코드는 이때 함께 버린다
     * (따로 청소할 시점이 없다 — 쓸 때 정리하지 않으면 옛 메뉴코드가 영영 남는다).
     * 저장 실패(저장소 차단 웹뷰·용량초과)는 Store 가 삼킨다 — 칩이 안 쌓일 뿐 화면은 그대로다.
     */
    _bumpMenuUse(code){
        const now = Math.floor(Date.now() / 1000);
        const cut = now - USE_KEEP_DAYS * 86400;
        const use = this._menuUse();

        const next = {};
        Object.keys(use).forEach((k) => { if( use[k] && use[k].t > cut ) next[k] = use[k]; });
        next[code] = { c: ((next[code] && next[code].c) || 0) + 1, t: now };

        $j.Common.Store.local.setJSON(this._useKey(), next);
    }

    /** 회원유형·권한에 따른 메뉴 구조(구 sitemap1/sitemap2 blade 대체). */
    _drawerSections(){
        const m = (typeof MEMBER !== 'undefined' && MEMBER) ? MEMBER : {};
        const isDriver = m.mem_driver_type === '수발주자';
        const isBaljoo = m.mem_driver_type === '발주자';
        const owner = !!(+m.isOwnerAuth);
        const admin = !!(G5 && G5.isAdmin);

        if( isDriver ){
            return [
                // tab: 상단 형제탭 라벨 — 3칸이 360px 를 나눠 쓰므로 탭에서는 '등록'으로 줄인다
                // (서랍 격자는 '서류등록' 유지 — 거기서는 무엇을 등록하는지가 먼저다)
                // 소속자(직원)는 서류·차고지를 직접 관리하지 않으므로 내정보만 노출
                { icon:'my.svg', title:'MY', items:[
                    { label:'내정보', code:'1010' },
                    owner && { label:'서류등록', tab:'등록', code:'1020' },
                    owner && { label:'위치', code:'1030' },
                ]},
                { icon:'regist.svg?123', title:'관리', items:[
                    { label:'특차리스트', code:'2020' },
                    { label:'수·발주 차단', code:'2030' },
                ]},
                'line',
                { icon:'charge.svg', title:'충전금', items:[
                    { label:'충전', code:'3010' },
                    { label:'출금', code:'3011' },
                    owner && { label:'사용내역', tab:'내역', code:'3032' },   // 탭은 충전·출금과 글자 수를 맞춘다
                ]},
                { icon:'point.svg?1212', title:'포인트', items:[
                    { label:'수주', code:'4010' },
                    // 발주개수는 -6차 화면(4020)에 흡수 — 두 자원이 한 흐름이라 메뉴를 나누지 않는다
                    { label:'발주', code:'4020' },
                ]},
                'line',
                // 1개짜리라 헤더 없는 단독 항목으로 그려진다 → 라벨이 곧 화면 이름이어야 한다('리스트' X)
                // 악덕알리미 연결 페이지(/m/relation/devil)로 간다 — 거기서 앱을 열거나 설치 안내로. 서랍 표식(↗ 앱 이동)은
                // 붙이지 않는다 — 본앱 화면을 한 번 거친다.
                { icon:'akduk.svg?212', title:'악덕업자', items:[
                    { label:'악덕업자', code:'6010' },
                ]},
                { icon:'card.svg?212', title:'장비대금 카드결제', head:'카드받기', items:[
                    { label:'결제', code:'5010' },
                    { label:'내역', code:'5011' },
                ]},
                'line',
                // tab: 상단 형제탭 라벨(서랍 격자는 짧게, 탭은 페이지 이름 그대로)
                { icon:'setting.svg', title:'설정', items:[
                    { label:'환경', tab:'환경설정', code:'7010' },
                    { label:'소리', tab:'소리설정', code:'7011' },
                ]},
                { icon:'info.svg', title:'고객지원', items:[
                    { label:'공지', code:'8010' },
                    { label:'고객센터', code:'8012' },
                ]},
            ];
        }

        // 발주자 / 업체발주자 등
        return [
            { icon:'my.svg', title:'MY', items:[
                { label:'내정보', code:'1010' },
                isBaljoo && { label:'서류등록', tab:'등록', code:'1020' },
            ]},
            { icon:'regist.svg?123', title:'관리', items:[
                { label:'특차리스트', code:'2020' },
                { label:'수주 차단', code:'2030' },
            ]},
            'line',
            { icon:'charge.svg', title:'충전금', items:[
                { label:'충전', code:'3010' },
                { label:'출금', code:'3011' },
                owner && { label:'사용내역', tab:'내역', code:'3032' },   // 탭은 충전·출금과 글자 수를 맞춘다
            ]},
            { empty:true },
            'line',
            { icon:'setting.svg', title:'설정', items:[
                { label:'환경', tab:'환경설정', code:'7010' },
                { label:'소리', tab:'소리설정', code:'7011' },
            ]},
            { icon:'info.svg', title:'고객지원', items:[
                { label:'공지', code:'8010' },
                { label:'고객센터', code:'8012' },
            ]},
        ];
    }

    /**
     * 대메뉴 바(top-nav-old) 손잡이 — 로고·전화 아이콘 탭 → 고객센터(1600-0421) 통화, 불러!톡 → goChat, 햄버거 → 서랍.
     * (구 top-nav-old 인라인 <script>·onclick 이관 — 소스보기 비노출) 매 페이지 Sites/Mobile/Bootstrap 이 호출한다.
     *
     * 개발 브릿지(/m/dev/bridge)로 가던 헤더 연속탭 진입은 없앴다 — 진입은 전체메뉴 '도메인 변경'(_devHtml)뿐이다.
     */
    bindHeaderTap(){
        const $logo = $('#hdr-logo-jb');
        if( !$logo.length || $logo.data('_hb') ) return;
        $logo.data('_hb', 1);
        $logo.on('click', () => { location.href = 'tel:1600-0421'; });
        $('#hdr-call').on('click', () => { document.location.href = 'tel:1600-0421'; });
        $('#hdr-chat').on('click', () => this.goChat());
        $('#hdr-drawer').on('click', () => this.openDrawer());
    }

    /**
     * 메뉴코드에 해당하는 url 로 이동한다.
     * @param menuCode
     */
    goMobileMenu(menuCode){
        const item = G5['MOBILE_MENU'][menuCode];
        if( !item || !item.url ){ console.warn('goMobileMenu: 알 수 없는 메뉴코드', menuCode); return; }
        const url = item.url;
        $('#PageMoveLoading').show();
        // 서랍 오버레이에서 이동(overlay 모드) — 항목 순증은 +1 이므로 jbReplaced(깊이 유지)는 세우지 않는다.
        // page 모드는 /m/menu 가 평범한 페이지라 여기 걸리지 않고 아래 location.href 로 간다.
        if( this._drawerPushed && $('#jbDrawer').hasClass('is-open') ){
            this._drawerPushed = false;
            location.replace(url);   // overlay 모드: 서랍이 쌓아둔 항목을 목적지로 대체
            return;
        }
        location.href = url;
    }

    /**
     * ✕(닫기) → 부모 메뉴로. 서랍에 없는 하위 화면(약관 → 고객센터)이 쓴다.
     * 현재 항목을 대체(replace)해 뒤로가기로 닫은 화면이 다시 나오지 않게 하고, 깊이는 유지한다
     * (jbReplaced 스탬프 — _stampDepth 참조. 형제탭은 이제 히스토리를 쌓으므로 여기만 replace 다)
     */
    goParentMenu(menuCode){
        const item = G5['MOBILE_MENU'][menuCode];
        if( !item || !item.url ){ this.goMainMenu(); return; }   // 잘못된 코드면 종전대로 대메뉴로
        $('#PageMoveLoading').show();
        this._ssSet('jbReplaced', '1');
        location.replace(item.url);
    }

    /**
     * ← (한 단계 돌아가기) — 서랍에 없는 하위 화면(약관 8013·8014, 비밀번호 변경 1011)의 좌측 버튼.
     *
     * parent 로 고정하면 안 된다: 약관은 고객센터 하단에도 있고 내정보 하단에도 있어서,
     * 내정보에서 들어온 회원까지 고객센터로 떨궈진다. 실제로 눌렀던 화면은 히스토리가 안다.
     * 히스토리가 없을 때(딥링크·새 탭으로 바로 열림)만 parent 로 간다.
     */
    goBackOrParent(menuCode){
        const st = history.state || {};
        const depth = (typeof st.jbDepth === 'number') ? st.jbDepth
                                                      : (parseInt(this._ssGet('jbDepth') || '0', 10) || 0);
        if( depth > 0 && history.length > 1 ){ history.back(); return; }
        this.goParentMenu(menuCode);
    }

    /**
     * 채팅 페이지로
     */
    goChat(){
        // 대리진입한 관리자도 그대로 들어간다 — 회원을 다시 찾아 들어가는 동선이 너무 길었다.
        // 보낸 말이 회원 말로 남지 않는 것은 서버가 지킨다: 발신자를 관리자 앱계정으로 치환하고
        // (ChatRoomService::resolveRoom), 치환할 계정이 없으면 입력창을 잠근다.
        $('#PageMoveLoading').show();

        // CS(모바일 관리자)는 상담창구인 /ma/chat 으로 곧장 보낸다.
        // CS 에게 '자기 불러톡'은 볼 일이 없는 화면인데, 상담하러 가려면 서랍 → 관리자 → 하단탭
        // 채팅까지 세 번을 눌러야 했다.
        // canEnter() 는 대리 중이면 false 라, 그때는 위 주석대로 (회원 계정의) 불러톡으로 들어간다.
        if( $j.F.Mobile.SiteSwitch.canEnter() ){
            location.href = '/ma/chat';
            return;
        }
        location.href="/m/chat";
    }

    /**
     * 로그아웃 다이얼로그 — 전체메뉴(서랍·/m/menu) 목록 끝의 로그아웃 pill 이 유일한 호출처
     * (_menuGridHtml). 내정보 푸터에는 두지 않는다.
     * 공용 모달 엔진($j.Ui.Modal)을 쓴다. 스타일은 sass/mobile/pages/_setting-my.scss.
     * (구 public/js/mobile.js 의 전역 askLogout)
     */
    askLogout(){
        const m = $j.Ui.Modal.open({
            title: '로그아웃',
            width: '320px',
            panelClass: 'smy-logout-modal',
            html: '<p class="smy-logout-msg">로그아웃 하시겠습니까?</p>'
                + '<div class="smy-logout-btns">'
                +   '<button type="button" class="smy-logout-btn is-cancel">취소</button>'
                +   '<button type="button" class="smy-logout-btn is-ok">로그아웃</button>'
                + '</div>',
        });
        m.el.on('click', '.is-cancel', () => m.close());
        m.el.on('click', '.is-ok', () => { document.location.href = '/m/logout'; });
    }

    /**
     * 회원상태 배너(#member-status-banner) — 탈퇴신청 등 비정상 상태를 셸 상단에 띄운다.
     * Sites/Mobile/Bootstrap 이 로그인 회원 매 페이지에서 부른다.
     * (구 public/js/mobile.js 의 전역 checkMemberStatus)
     */
    showMemberStatusBanner(){
        // 회원상태 안내 화면(/m/member/wait, body.jb-wait) 자체에는 띄우지 않는다 — 화면 전체가 그 상태 안내라
        // 배너가 겹치면 앱바 제목만 가린다
        if (document.body.classList.contains('jb-wait')) return;
        let html = ``;
        const status = Util.int(MEMBER['mem_status']);
        if( status>0 ) {
            let str = G5['MEMBER_STATUS'][status];
            html = `⚠️ ${str} 상태입니다.`;
        }
        if( Store.cookie.get(G5['CK_LEAVE_RQ'])!='Y' && MEMBER['is_leave_request']>0 ){
            html = `<div style="position:relative; padding:10px 0; font-size:14px; color: #fff;" id='leave-info-call'>
                ⚠️ 탈퇴신청 상태입니다.<br>
                관리자와 통화 이후 최종 탈퇴처리 가능합니다.<br>
                <p style="display: flex; align-items: center; justify-content: center; gap: 5px; color: #fff;">
                    <img src="/img/callimg.png" alt="call" style="width: 20px; height:auto;">고객센터 : 1600-0421
                </p>
                <i class="fas fa-times" style="position: absolute; top: 0; right:5px; font-size:16px; color: #fff;" id="leave-info-close-btn"></i>
            </div>`;
        }
        if(html) $('#member-status-banner').html(html).show();

        $('#leave-info-close-btn').on('click', function (e) {
            e.stopPropagation();
            Store.cookie.set(G5['CK_LEAVE_RQ'], 'Y', { days: 1 });
            $('#member-status-banner').hide();
        });
        $('#leave-info-call').on('click', function(){
            location.href = 'tel:16000421';
        });
    }

}